
import axios from 'axios';
import Cookies from 'js-cookie'
import Qs from 'qs'
import { Message } from 'element-ui';
import { Loading } from 'element-ui';
import myVue from "../main.js";


let loading;
let loadingNum = 0;

function startLoading() {
	let lang = Cookies.get('lang')
	// lang==>1 英文
	// lang==>2 中文
	var title = '拼命加载中...'
	if(lang==1){
		title = 'Loading...'
	}
	if (loadingNum == 0) {
		// loading = Loading.service({
		// 	spinner: 'el-icon-loading',
		// 	lock: true,
		// 	text: title,
		// 	background: 'rgba(255,255,255,0.5)',
		// 	target: document.querySelector('.content')
		// })
		loading = Loading.service({
			// spinner: 'el-icon-loading',
			lock: true,
			text: '',
			background: 'rgba(255,255,255,0)',
			target: document.querySelector('.content')
		})
	}
	loadingNum++;
}




function endLoading() {  //  关闭动画
	// loadingNum--;
	// if (loadingNum <= 0) {
	// 	loading.close();
	// }
	loading.close();
}

export function http(url, data, method, sing) {
	startLoading();
	// console.log(data)
	// console.log('sing==>',)
	let token
	let user_data = JSON.parse(localStorage.getItem('user_data'))
	if (!user_data) {
		token = ''
	} else {
		token = JSON.parse(localStorage.getItem('user_data')).token
	}

	let _this = this
	
	// https://billiard123.com
	// http://hfyl.zhilongsoft.com
	
	return new Promise((resolve, reject) => {
		axios({
			headers: {
				"Content-Type": "application/x-www-form-urlencoded",
				'Lang': Cookies.get('lang'),
				'Api-Token': sing || '',
				'User-Token': token

			},
			timeout: 10000,
			method: method,
			data: Qs.stringify(data),
			baseURL: 'https://www.taiqiu123.com' + url
		}).then(res => {
			endLoading();  //  关闭动画
			if (res.status == 200) {

				if (res.data.code == 1) {
					resolve(res)
				} else {
					if (res.data.msg) {
						console.log(res.data.msg)
						if(res.data.msg == 'User-Token错误'){
							// console.log(myVue.$t('m.MallCenter_22'))
							localStorage.removeItem('user_data')
							Message.warning(myVue.$t('m.MallCenter_22'));
							setTimeout(function(){
								myVue.$router.push({
								    path: '/account/login'
								})
							},2000)
						}else{
							Message.warning(res.data.msg);
						}
						
					}
					resolve(res)
				}
			} else if (res.statusCode == 404) {
				Message.warning('找不到资源');
			} else {
				Message.warning('网络请求超时');

			}

			//失败
		}).catch(err => {
			endLoading();  //  关闭动画
			console.log('err=>', err);
			Message.error('网络连接超时，请刷新重试');
			reject(err);
		})
	});



}

export function uploadFile(url, formdata, sing) {
	startLoading();
	let token
	let user_data = JSON.parse(localStorage.getItem('user_data'))
	if (!user_data) {
		token = ''
	} else {
		token = JSON.parse(localStorage.getItem('user_data')).token
	}

	let _this = this
	return new Promise((resolve, reject) => {
		axios.post('https://www.taiqiu123.com' + url, formdata, {
			"Content-Type": "multipart/form-data",
			'Lang': Cookies.get('lang'),
			'Api-Token': sing || '',
			'User-Token': token
		}).then(res => {
			endLoading();  //  关闭动画
			if (res.status == 200) {
				if (res.data.code == 1) {
					resolve(res)
				} else {
					if (res.data.msg) {
						Message.warning(res.data.msg);
					}
					reject(res)
				}
			} else if (res.statusCode == 404) {
				Message.warning('找不到资源');
			} else {
				Message.warning('网络请求超时');

			}

			//失败
		}).catch(err => {
			endLoading();  //  关闭加载动画
			console.log('err=>', err);
			Message.error('网络连接超时！');
			reject(err);
		})
		// 	axios({
		// 		headers: {
		// 			"Content-Type": "multipart/form-data",
		// 			'Lang': Cookies.get('lang'), //语言代码,
		// 			'Api-Token': sing || '',
		// 			'User-Token': token

		// 		},
		// 		timeout: 10000,
		// 		name: 'file', 
		// 		filePath: filePath,
		// 		method: 'post',
		// 		formData: { 'user': 'test' },
		// 		baseURL: 'https://billiard123.com' + url
		// 	}).then(res => {
		// 		endLoading();  //  关闭加载动画
		// 		if (res.status == 200) {
		// 			if (res.data.code == 1) {
		// 				resolve(res)
		// 			} else {
		// 				if (res.data.msg) {
		// 					Message.warning(res.data.msg);
		// 				}
		// 				reject(res)
		// 			}
		// 		} else if (res.statusCode == 404) {
		// 			Message.warning('找不到资源');
		// 		} else {
		// 			Message.warning('网络请求超时');

		// 		}

		// 		//失败
		// 	}).catch(err => {
		// 		endLoading();  //  关闭加载动画
		// 		console.log('err=>', err);
		// 		Message.error('网络连接超时！');
		// 		reject(err);
		// 	})
	});



}




